import { SUPPORTED_OFFERS, SUPPORTED_PRICELISTS, SUPPORTED_STORAGES } from '@config/index';
import getPublicEnv from '@utils/getPublicEnv';

const getOffer = (): string[] => {
  const offer = process.env.OFFER || getPublicEnv('NEXT_PUBLIC_OFFER') || SUPPORTED_OFFERS.mx;
  const priceList =
    process.env.OFFER_PRICELIST || getPublicEnv('NEXT_PUBLIC_OFFER_PRICELIST') || SUPPORTED_PRICELISTS.mx;
  const storage = process.env.OFFER_STORAGE || getPublicEnv('NEXT_PUBLIC_OFFER_STORAGE') || SUPPORTED_STORAGES.mx;

  return [offer, priceList, storage];
};

export default getOffer;
